var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { device } from '../../breakpoints';
var LogoButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 48px;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n\n  @media ", " {\n    height: 40px;\n  }\n"], ["\n  height: 48px;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n\n  @media ", " {\n    height: 40px;\n  }\n"])), device.laptop);
var LogoAnchor = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media ", " {\n    display: inline;\n    vertical-align: baseline;\n    line-height: normal;\n    font-size: 1rem;\n  }\n"], ["\n  @media ", " {\n    display: inline;\n    vertical-align: baseline;\n    line-height: normal;\n    font-size: 1rem;\n  }\n"])), device.laptop);
export var LogoClickableWrapper = function (props) {
    var buttonProps = props;
    var anchorProps = props;
    return (React.createElement(React.Fragment, null,
        (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) && React.createElement(LogoButton, __assign({}, buttonProps)),
        (anchorProps === null || anchorProps === void 0 ? void 0 : anchorProps.href) && React.createElement(LogoAnchor, __assign({}, anchorProps), " ")));
};
var templateObject_1, templateObject_2;
